export default __webpack_public_path__ + "static/media/techCampBg.870ea67a.jpg";